<template>
  <svg :width="width" :height="height" viewBox="0 0 18 5" fill="none">
    <path
      d="M2 2.49756H2.01M9 2.49756H9.01M16 2.49756H16.01M3 2.49756C3 3.04984 2.55228 3.49756 2 3.49756C1.44772 3.49756 1 3.04984 1 2.49756C1 1.94527 1.44772 1.49756 2 1.49756C2.55228 1.49756 3 1.94527 3 2.49756ZM10 2.49756C10 3.04984 9.55228 3.49756 9 3.49756C8.44772 3.49756 8 3.04984 8 2.49756C8 1.94527 8.44772 1.49756 9 1.49756C9.55228 1.49756 10 1.94527 10 2.49756ZM17 2.49756C17 3.04984 16.5523 3.49756 16 3.49756C15.4477 3.49756 15 3.04984 15 2.49756C15 1.94527 15.4477 1.49756 16 1.49756C16.5523 1.49756 17 1.94527 17 2.49756Z"
      :stroke="color"
      :stroke-width="strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  width: {
    type: [String, Number],
    default: "18",
  },
  height: {
    type: [String, Number],
    default: "5",
  },
  color: {
    type: String,
    default: "#3B4648",
  },
  strokeWidth: {
    type: [String, Number],
    default: "2",
  },
});
</script>
